import {Box, Button, Flex, Image, Text} from '@chakra-ui/react'
import {EXAM_BODY_TYPE, EXAM_TITLE_TYPE} from '@pages/ExamPage/examPageModel'
import {CommonColors} from '@utils/CommonStyles'
import PersonExamRoomImage from '@assets/images/exam/person-exam-room.png'
import renderTextWithLineBreaks from './shared/renderTextWithLineBreaks'

function DescribeItem({data, handleStart}: any) {
  const handleMoveToQuestionList = () => {
    handleStart(EXAM_BODY_TYPE.QUESTION_LIST)
  }
  return (
    <Flex flex={1}>
      <Flex position={'relative'} w={'600px'} ml={'24px'} display={{ base: 'none', md: 'flex' }}>
        <Image
          maxH={'100%'}
          position={'absolute'}
          bottom={0}
          src={PersonExamRoomImage}
          objectFit={'contain'}
        />
      </Flex>
      <Flex
        w={'100%'}
        alignSelf={'flex-start'}
        justifyContent={'start'}
        mt={'50px'}>
        <Flex
          bgColor={CommonColors.white}
          w={'700px'}
          minH={'500px'}
          maxH={'80vh'}
          borderRadius={24}
          alignItems={'center'}
          flexDirection={'column'}
          mb={'60px'}>
          <Text paddingY={'18px'} fontSize={{base: 24, md: 32, lg: 38}} fontWeight={700}>
            {EXAM_TITLE_TYPE[data?.type as keyof typeof EXAM_TITLE_TYPE]}
          </Text>
          <Box
            flex={1}
            paddingX={'20px'}
            fontSize={{base: 16, md: 18, lg: 20}}
            fontWeight={400}
            textAlign={'left'}
            overflowY={'auto'}
            width={'100%'}>
            {renderTextWithLineBreaks(data?.instruction || '')}
          </Box>
          <Button
            _hover={{bg: CommonColors.blue}}
            borderRadius={'16px'}
            bg={CommonColors.blue2}
            marginY={'30px'}
            color={CommonColors.white}
            w={'92px'}
            fontWeight={700}
            onClick={handleMoveToQuestionList}>
            Bắt đầu
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default DescribeItem
